export default __webpack_public_path__ + "static/media/stars.02575c98.svg";